export default "__VITE_ASSET__Civ_9215__"